const CRAFT_GALLERY_IMAGES = [
  {
    src: 'https://BelvoirCastle.b-cdn.net/Halloween/Crafts/444fce2e-0184-4312-895b-1551c6e7e86e.JPG',
    alt: 'Painted pumpkin monster faces with sticker eyes and teeth on black card'
  },
  {
    src: 'https://BelvoirCastle.b-cdn.net/Halloween/Crafts/WhatsApp%20Image%202026-10-20%20at%2014.25.36%20(1).webp',
    alt: 'A handmade Happy Halloween card with a grinning pumpkin face'
  },
  {
    src: 'https://BelvoirCastle.b-cdn.net/Halloween/Crafts/WhatsApp%20Image%202026-10-20%20at%2014.25.42%20(1).webp',
    alt: 'A tissue-paper ghost craft held up in front of the Balloon Bar sign'
  },
  {
    src: 'https://BelvoirCastle.b-cdn.net/Halloween/Crafts/WhatsApp%20Image%202026-10-20%20at%2014.25.42%20(3).webp',
    alt: 'Halloween craft table set out with card shapes, face stickers and chalks'
  }
];

export default CRAFT_GALLERY_IMAGES;
